<template>
  <div>
    <!--功能按钮组件页面-->
    <avue-crud :data="list" :option="tableOption" :page="page" @size-change="sizeChange" @current-change="currentChange" @search-reset="searchReset" @row-click="showRow" @search-change="searchChange">
      <template slot="search">
        <el-form-item label="名称">
          <el-input v-model="listQuery.name" clearable placeholder="请输入名称" size="small"/>
        </el-form-item>
      </template>
      <template slot="menuLeft">
         <el-button v-if="sys_user_add" class="filter-item" size="mini" @click="handleCreate" type="primary" icon="el-icon-plus">添加
        </el-button>
        <el-button v-if="sys_user_edit" class="filter-item" size="mini" @click="handleUpdate" type="primary" icon="el-icon-edit-outline" :disabled = "totalStatus">编辑
        </el-button>
        <el-button v-if="sys_user_cold" class="filter-item" size="mini" @click="handleStop" type="primary" icon="el-icon-circle-close-outline" :disabled = "statuscold">冻结
        </el-button>
        <el-button v-if="sys_user_nocold" class="filter-item" size="mini" @click="handleStart" type="primary" icon="el-icon-circle-check-outline" :disabled = "statusnocold">解冻
        </el-button>
        <el-button v-if="sys_user_uppass" class="filter-item" size="mini" @click="handleChangePwd" type="primary" icon="el-icon-refresh" :disabled = "totalStatus">更改密码
        </el-button>
        <el-button v-if="sys_user_rote" class="filter-item" size="mini" @click="handleChangRole" type="primary" icon="el-icon-more-outline" :disabled = "totalStatus">角色分配
        </el-button>
      </template>
      <template slot-scope="scope" slot="id">
          <el-radio class="radio" v-model="radio"  :label="scope.row.id"></el-radio>
      </template>
    </avue-crud>
      <edit ref="child2" @refresh="refresh"></edit>
      <assetrole  ref="child" @refresh="refresh"></assetrole>
      <updata ref="child1" @refresh="refresh"></updata>
 </div>
</template>
<script>
    import {fetchList,stop} from '@/api/admin/user'
    import waves from '@/directive/waves/index.js' // 水波纹指令
    import {objKeySort} from '@/util/ajaxsign'
    import {dateOnce} from '@/util/dateT'
    import assetrole from './assetrole.vue'
    import updata from './updata.vue'
    import edit from './edit.vue'
import { debuglog } from 'util';
    export default {
        name: 'table_user',
        components: {assetrole,updata,edit},
        directives: { waves },
        data() {
            return {
                radio : '',
                list: [],
                listLoading : false,
                listQuery: {
                  current: 1,
                  size: 10,
                  name : ''
                },
                page: {
                  pageSizes: [10, 20, 50, 100],
                  currentPage: 1,
                  total: 0,
                  pageSize: 10
                },
                tableOption : {
                  addBtn : false,
                  refreshBtn : false,
                  columnBtn : true,
                  editBtn : true,
                  delBtn : true,
                  menu : false,
                  page:true,
                  border : true,
                  align:'center',
                  menuAlign:'center',
                  height : window.innerHeight - 290,
                  index:false,
                  column:[
                    {
                      label:'',
                      prop:'id',
                      width:40,
                      solt:true
                    },
                  {
                      label:'账号',
                      minWidth:120,
                      prop:'account'
                    },{
                      label:'姓名',
                      minWidth:120,
                      prop:'name'
                    },{
                      label:'部门',
                      prop:'deptName',
                      minWidth:120
                    },{
                      label:'电话',
                      width:120,
                      prop:'phone'
                    },{
                      label:'角色',
                      prop:'roleName',
                      width:180,
                      overHidden : true
                    },{
                      label:'状态',
                      prop:'status',
                      minWidth:80,
                      formatter: function(row){
                         return  row.status ==1? '正常' : '冻结'
                      },
                    },{
                      label:'创建时间',
                      prop:'createtime',
                      type: 'date',
                      minWidth:160,
                      format: 'yyyy-MM-dd HH:mm:ss',
                      valueFormat: 'yyyy-MM-dd HH:mm:ss'
                    }
                  ]
                },
                permissions : [], //权限数据
                treeDeptData : [],
                totalStatus:true, // 默认不选择按钮禁用
                statuscold : true,
                statusnocold : true,
                userId : '',
                formdata : []
            }
        },
        created() {
          this.getList();
          window.sessionStorage.getItem("userInfo");
          this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
          for(var i=0;i<this.permissions.length;i++){
            if(this.permissions[i] == 'sys_user_add'){
              this.sys_user_add = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_user_edit'){
              this.sys_user_edit = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_user_del'){
              this.sys_user_del = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_user_cold'){
              this.sys_user_cold = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_user_nocold'){
              this.sys_user_nocold = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_user_uppass'){
              this.sys_user_uppass = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_user_rote'){
              this.sys_user_rote = this.permissions[i]
            }
            if(this.permissions[i] == 'sys_user_del'){
              this.sys_user_del = this.permissions[i]
            }
          }
        },
        methods: {
            //刷新列表操作
            refresh(){
              this.totalStatus = true;
              this.statuscold = true;
              this.statusnocold = true;
              this.getList()
            },

            //获取列表数据
            getList() {
                this.listLoading = true;
                this.listQuery.isAsc = false;
                fetchList(objKeySort(this.listQuery)).then(response => {
                  this.list = response.data.data.rows;
                  this.list.createtime=dateOnce(response.data.data.createtime);
                  this.page.total = response.data.data.total;
                  this.listLoading = false;
                  this.radio = '';
                })
            },
            //点击列数据
            showRow(row){
                this.radio = row.id;
                this.setsataus(row.status);
                this.radioUser(row);
            },
            // 获取列表某一项得值
            radioUser(val) {
                this.$emit('data',val.pkg);
                this.setdata(val);
            },

            //清空
            searchReset(){
              this.listQuery={};
              this.listQuery.current = 1;
              this.listQuery.size = 20;
              this.getList();
            },

            //条数
            sizeChange(val) {
              this.listQuery.size = val;
              this.getList();
            },
            //页码
            currentChange(val) {
              this.listQuery.current = val;
              this.getList();
            },
            //搜索数据
            searchChange(){
              this.getList();
            },
             //设置数据
            setdata(data){
              this.userId = data.id;
              this.formdata = data;
            },
            setsataus(data){
                // //处理冻结或解冻为题
              this.totalStatus = false;    // 子组件按钮的是否允许操作
              if(data == 1){
                  this.statuscold = false;
              }else{
                  this.statusnocold = false;
              }
            },
            //冻结
            handleStop() {
              stop(objKeySort({userId:this.userId,status:2})).then(response =>{
                console.log(response)
                this.$message({
                      title: '冻结成功',
                      message: '冻结成功',
                      type: 'success',
                      duration: 2000
                    })
                  this.refresh();
              })
            },
            //解冻
          handleStart(){
              stop(objKeySort({userId:this.userId,status:1})).then(response =>{
                console.log(response)
                this.$message({
                  title: '解冻成功',
                  message: '解冻成功',
                  type: 'success',
                  duration: 2000
                })
                this.refresh();
              })
            },

            //删除数据
            handledel(){
              this.$confirm(
                '此操作将永久删除该用户(用户名:' + this.formdata.name + '), 是否继续?',
                '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              ).then(() => {
                stop(objKeySort({userId:this.userId,status:3})).then(response =>{
                  console.log(response)
                  this.$message({
                        title: '删除成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                      })
                      this.refresh();
                })
              })
            },

            //新增
            handleCreate(){
             // debugger
              this.$refs.child2.dialog('create',{});
   
            },

            //修改
            handleUpdate(){
              //不修改接口，直接通过添加属性来解决编辑的回显问题
              this.formdata.roleId = this.formdata.roleid;
              this.$refs.child2.dialog('update',this.formdata);
            },

            //调用更改密码组件
            handleChangePwd(){
              // 子组件按钮的是否允许操作
              this.$refs.child1.setuserid(this.formdata.id);
            },

            //调用设置角色组件
            handleChangRole(){
              console.log(this.formdata);
              this.$refs.child.setuserid(this.formdata.id,this.formdata.roleid);
            }
        }
    }
</script>
<style lang="scss" scoped>

  .el-tag{
    border: 0!important;
    color: #666!important;
    background-color: transparent;
    font-size:14px;
  }
  .dialog-footer{
    margin-left: 0!important;
  }
  .filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }
  .el-table__row:nth-child(even) {
    background-color: #F6F9FF!important;
  }
  /*.select_role{
    -height:100px;
  }*/
  .el-dialog__footer{
    -height:120px;
  }
  .p1{
    width:100% !important;
  }
  .part{
    position: relative;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-radio__label{
    display:none;
  }
</style>
